import { render } from "./MessageOverlay.vue?vue&type=template&id=2b1675c2&scoped=true"
import script from "./MessageOverlay.vue?vue&type=script&lang=js"
export * from "./MessageOverlay.vue?vue&type=script&lang=js"

import "./MessageOverlay.vue?vue&type=style&index=0&id=2b1675c2&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1675c2"]])

export default __exports__